export const parseCSVtoJson = csvData => {
  const lines = csvData.split('\n')
  const headers = lines[0].split(';')

  const result = []

  for (let i = 1; i < lines.length; i++) {
    const obj = {}
    const currentLine = lines[i].split(';')

    for (let j = 0; j < headers.length; j++) {
      obj[headers[j].trim()] = currentLine[j]?.replace(/^"|"$/g, '').trim() || ''
    }

    result.push(obj)
  }

  return result
}

const csvMaker = function (data) {
  const csvRows = []
  const headers = Object.keys(data)

  csvRows.push(headers.join(','))

  const values = Object.values(data).join(',')
  csvRows.push(values)

  return csvRows.join('\n')
}

export const downloadCSVExample = () => {
  const data = {
    email: '',
    password: '',
    fullName: '',
    organizationId: '',
    roleId: '',
    platforms: '',
  }
  const csvData = csvMaker(data)

  const blob = new Blob([csvData], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', 'create users example.csv')
  a.click()
}
